module.exports = __webpack_public_path__ + "static/img/21.ae5d5668.jpg";